<template>
  <div id="app">
    <router-view />
    <!-- 图片预览 -->
    <!-- 视频预览 -->
    <!-- 音频预览 -->
    <MediaPreview />
    <!-- 将上传组件全局注册 -->
    <global-uploader :global="false" />
  </div>
</template>

<script>
import MediaPreview from '@/components/MediaPreview'
import GlobalUploader from '@/components/vue-simple-uploader/GlobalUploader'
export default {
  name: 'App',
  components: {
    MediaPreview,
    GlobalUploader
  }
}
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

@media screen and (max-width: 768px) {
  .el-message {
    min-width: 300px !important;
  }
  .el-message-box {
    width: 300px !important;
  }
  .el-dialog__wrapper .el-dialog {
    width: 95% !important;

    .el-dialog__body {
      padding: 10px 20px !important;
    }
  }
  .el-date-range-picker {
    left: 0 !important;
  }

  .el-form-item__label {
    display: block;
    width: 100% !important;
    text-align: left;
  }
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
